import { investorsSection as defaultInvestorsSection } from '~/content/shared';
import { Section, SectionHeading } from '~/components/layout';

/** "Backed by the same investors as the world's best" logo grid (Figma 89:1947). */
export function InvestorsGrid({
  content: investorsSection = defaultInvestorsSection,
}: {
  content?: typeof defaultInvestorsSection;
} = {}) {
  return (
    // 200px gaps to neighbours: safe-space above (80px margin + 120px) and the
    // testimonial grid below (100px + its 100px top).
    <Section className="!pt-[120px] !pb-[100px]">
      <SectionHeading title={investorsSection.title} />
      <ul className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">
        {investorsSection.logos.map((logo) => (
          <li
            key={logo.name}
            className="flex h-[120px] items-center justify-center bg-grey-25 px-6 lg:h-[168px]">
            <img
              src={logo.src}
              alt={logo.name}
              loading="lazy"
              decoding="async"
              className="max-h-[33.6px] w-auto max-w-[98px] object-contain md:max-h-12 md:max-w-[140px]"
            />
          </li>
        ))}
      </ul>
    </Section>
  );
}
